//
// Game Loader
//

Loader = {};
Loader.isLoaded = false;
Loader.minTimerExpired = false;
Loader.readyForSplash = false;
autoplayManager.containerName = 'autoplayContainer:autoplayBackground';

Loader.initialise = function (container) {
  Loader.container = container;

  // Loader.doTextMapping();

  // Setup callback functions
  resourceManager.registerLoadCompleteCallback(Loader.onLoadComplete);
  resourceManager.registerLoadProgressCallback(Loader.onLoadProgress);
  Reflex.registerEventHandler('ready', Loader.onLayoutComplete);
};

Loader.onResize = function (width, height, isLandscape) {
  if (Loader.loaderBackground !== undefined) {
    var scale = Math.max(
      width / Loader.loaderBackground.texture.width,
      height / Loader.loaderBackground.texture.height
    );
    Loader.loaderBackground.scale.x = scale;
    Loader.loaderBackground.scale.y = scale;
    Loader.loaderBackground.position.x = width / 2;
    Loader.loaderBackground.position.y = height / 2;
  }
};

Loader.onLoadComplete = function (loadGroup, resources) {
  if (loadGroup === 'loading') {
    Loader.progressBar = resourceManager.get('loadingBarFrame:loadingProgressBack');
    Loader.setLoadProgress(0);
    resourceManager.getContainer('loadingContainer').visible = true;
    resourceManager.getContainer('backgroundContainer').visible = false;
    resourceManager.getContainer('splashContainer').visible = false;
    resourceManager.getContainer('darkOverlayContainer').visible = true;

    const loadingData = gdk.getPlatformLoadingData();
    let isGamCareLogoVisible = checkForDefined(loadingData.gamCareLogo) ? loadingData.gamCareLogo : false;
    let isPreloadMessageVisible = checkForDefined(loadingData.message);
    resourceManager.get('GamCareContainerPreLoad:gamCareLogo').visible = isGamCareLogoVisible;
    resourceManager
      .get('GamCareContainerPreLoad:preLoadMessage')
      .setText(isPreloadMessageVisible ? loadingData.message : '');
    resourceManager.get('GamCareContainerPreLoad').visible =
      isGamCareLogoVisible || (isPreloadMessageVisible && loadingData.message.length != 0);

    if (isPreloadMessageVisible) {
      // YG requirement, we need to give player 5 seconds to read preloader message
      timerManager.addTimer(5000, undefined, function () {
        Loader.minTimerExpired = true;
        Loader.checkCanGoToSplash();
      });
    } else {
      Loader.minTimerExpired = true;
      Loader.checkCanGoToSplash();
    }
  }
};

Loader.onLoadProgress = function (percent, loadGroup) {
  if (loadGroup !== 'loading') {
    Loader.setLoadProgress(percent);
  }
};

Loader.onLayoutComplete = function () {
  Loader.setLoadProgress(1);
  // gameData.stakeMeter = resourceManager.get("meterContainer:stake:meter");
  // gameData.creditMeter = resourceManager.get("meterContainer:credit:meter");
  // gameData.winningsMeter = resourceManager.get("meterContainer:winnings:meter");
  // gameData.winningsMeterTitle = resourceManager.get(
  //   "meterContainer:winnings:title"
  // );
  gameData.screenDim = resourceManager.get('backgroundScreenDimObject');
  //messageBus.subscribe("spinner:GameConfigEvent", Loader.onGameConfigEvent);

  // loading bar finished - hide now whilst waiting for player to continue
  // resourceManager.get( "loader:loadingBarBack" ).visible = false;
  // resourceManager.get( "loader:loadingBarFrame" ).visible = false;
  // resourceManager.get( "loader:loadingProgressBack" ).visible = false;
  // resourceManager.get( "loader:loadingText" ).visible = false;
};

Loader.onGameConfigEvent = function (gameConfigTask) {
  gameData.reels = [];
  gameData.nudgeReels = [];
  gameData.reelAnimations = [];
  gameData.bonusSymbols = [];
  gameData.inputOverlord = resourceManager.getController('inputOverlord');
  gameData.inputOverlord.setState('disabled');
  gameData.slotConfig = gameConfigTask.data.slotConfig;

  gameData.maxExposure = gameConfigTask.data.maxExposure;

  if (gameConfigTask.data.savedClientData) {
    var encoreData = gameConfigTask.data.savedClientData.meta.find(function (element) {
      return element.name === 'encore';
    });
  }

  var enableEncoreButton = encoreData && encoreData.enabled;

  if (enableEncoreButton && !gameConfigTask.data.slotConfig.promotionActive) {
    // task.data.metaValue is set to true if recovering encore game
    gameData.encoreEnabled = true;

    // Put button in the right state if not already true
    var encoreButtonLB = resourceManager.get('backgroundButtons:luckyBetToggleButton');

    if (encoreButtonLB._flags.showLuckyBetActive !== gameData.encoreEnabled) {
      encoreButtonLB.setRecovery();
    }

    resourceManager.getController('stakeController').setStakeMultiplier(encoreData.value);
    game.changeStake(resourceManager.getController('stakeController').CurrentStake);
    game.resetWinnings();
    resourceManager.getController('stakeController').broadcastCurrentStake();
  }

  let backgroundLandscape = resourceManager.get('splashBackground1:splashBackgroundL');
  let backgroundLandscape2 = resourceManager.get('splashBackground2:splashBackgroundL2');
  let backgroundLandscape3 = resourceManager.get('splashBackground3:splashBackgroundL3');
  backgroundLandscape.interactive = true;
  backgroundLandscape2.interactive = true;
  backgroundLandscape3.interactive = true;

  // First splash screen click handler
  backgroundLandscape.setInteractiveCallbacks(function () {
    backgroundLandscape.interactive = false;
    backgroundLandscape.visible = false;
    backgroundLandscape2.visible = false;
    backgroundLandscape2.interactive = false;
    backgroundLandscape3.visible = false;
    backgroundLandscape3.interactive = false;
    gdk.loadingClosed();
    Reflex.updateViewport();
  }, true);

  backgroundLandscape2.setInteractiveCallbacks(function () {
    backgroundLandscape.interactive = false;
    backgroundLandscape.visible = false;
    backgroundLandscape2.visible = false;
    backgroundLandscape2.interactive = false;
    backgroundLandscape3.visible = false;
    backgroundLandscape3.interactive = false;
    gdk.loadingClosed();
    Reflex.updateViewport();
  }, true);

  backgroundLandscape3.setInteractiveCallbacks(function () {
    backgroundLandscape.interactive = false;
    backgroundLandscape.visible = false;
    backgroundLandscape2.visible = false;
    backgroundLandscape2.interactive = false;
    backgroundLandscape3.visible = false;
    backgroundLandscape3.interactive = false;
    gdk.loadingClosed();
    Reflex.updateViewport();
  }, true);

  // Portrait mode - still uses single splash for now
  let backgroundPortrait = resourceManager.get('splashBackground1:splashBackgroundP');
  let backgroundPortrait2 = resourceManager.get('splashBackground2:splashBackgroundP2');
  let backgroundPortrait3 = resourceManager.get('splashBackground3:splashBackgroundP3');
  backgroundPortrait.interactive = true;
  backgroundPortrait2.interactive = true;
  backgroundPortrait3.interactive = true;

  backgroundPortrait.setInteractiveCallbacks(function () {
    backgroundPortrait.interactive = false;
    backgroundPortrait.visible = false;
    backgroundPortrait2.interactive = false;
    backgroundPortrait2.visible = false;
    backgroundPortrait3.visible = false;
    backgroundPortrait3.interactive = false;
    gdk.loadingClosed();
    Reflex.updateViewport();
  }, true);

  backgroundPortrait2.setInteractiveCallbacks(function () {
    backgroundPortrait.interactive = false;
    backgroundPortrait.visible = false;
    backgroundPortrait2.interactive = false;
    backgroundPortrait2.visible = false;
    backgroundPortrait3.visible = false;
    backgroundPortrait3.interactive = false;
    gdk.loadingClosed();
    Reflex.updateViewport();
  }, true);

  backgroundPortrait3.setInteractiveCallbacks(function () {
    backgroundPortrait.interactive = false;
    backgroundPortrait.visible = false;
    backgroundPortrait2.interactive = false;
    backgroundPortrait2.visible = false;
    backgroundPortrait3.visible = false;
    backgroundPortrait3.interactive = false;
    gdk.loadingClosed();
    Reflex.updateViewport();
  }, true);

  gameData.slotConfig = gameConfigTask.data.slotConfig;

  game.stopDistances = gameConfigTask.data.stopDistances;

  // Link buttons to functions
  game.initialise(gameConfigTask);

  Loader.setStartingSymbols();
  Loader.setStartingNudgeSymbols();

  const slotMachine = resourceManager.getController('SlotMachine');
  for (let i = 0; i < slotMachine.reels.length; i++) {
    const reel = resourceManager.get('mainReelsContainer:slotContainer:reelContainer:reel' + i);
    gameData.reels.push(reel);
  }

  game.autoClickForReplayRewatch(() => {
    backgroundPortrait.interactive = false;
    backgroundPortrait.visible = false;
    backgroundPortrait2.interactive = false;
    backgroundPortrait2.visible = false;
    backgroundPortrait3.visible = false;
    backgroundPortrait3.interactive = false;
    gdk.loadingClosed();
    Reflex.updateViewport();
  });

  Loader.readyForSplash = true;

  Loader.checkCanGoToSplash();
};

Loader.setStartingSymbols = function () {
  const slotMachine = resourceManager.getController('SlotMachine');
  for (let i = 0; i < slotMachine.reels.length; i++) {
    const reel = resourceManager.get('mainReelsContainer:slotContainer:reelContainer:reel' + i);
    const startingSymbols = gameData.slotConfig.startingSymbols[i].symbols;
    const reelLength = gameData.slotConfig.startingSymbols[i].symbols.length;

    // Copy starting symbols from server
    for (let j = 0; j < reelLength; ++j) {
      reel.setReelSymbol(j, startingSymbols[j].value);
    }
  }
};

Loader.setStartingNudgeSymbols = function () {};

Loader.checkCanGoToSplash = function () {
  if (Loader.readyForSplash && Loader.minTimerExpired) {
    Loader.readyForSplash = false;
    Loader.minTimerExpired = false;
    Loader.progressBar.scale.x = 1;

    // Hide loading container and show splash
    resourceManager.getContainer('loadingContainer').visible = false;
    resourceManager.getContainer('splashContainer').visible = true;

    game.features.push(resourceManager.get('splashBackground1'));
    game.features.push(resourceManager.get('splashBackground2'));
    game.features.push(resourceManager.get('splashBackground3'));

    game.featureAutoTimeline = gsap.timeline({ repeat: -1 }).call(
      () => {
        game.swapFeature(-1);
      },
      undefined,
      '<+=5'
    );
  }
};

Loader.setLoadProgress = function (percent) {
  var width = Loader.progressBar.texture.baseTexture.width * percent;
  Loader.progressBar.texture.frame = new PIXI.Rectangle(0, 0, width, Loader.progressBar.texture.baseTexture.height);
};

messageBus.subscribe('spinner:GameConfigEvent', Loader.onGameConfigEvent);
